import type {HelpFile} from '../../types/help'
import {WizardStepBasicsTestIds} from '../../../testids/WizardStepBasicsTestIds'

export const wizardStepBasicsHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [WizardStepBasicsTestIds.inputPolicyName]:
            'Eindeutiger Richtlinienname, der in Kampagnenlisten angezeigt wird.',
        [WizardStepBasicsTestIds.inputPolicyDescription]: null,
        [WizardStepBasicsTestIds.inputPolicyPriority]:
            'Steuert die Reihenfolge, wenn mehrere Richtlinien auf dieselbe Zuweisung zutreffen. Niedrigere Werte werden zuerst ausgewertet.',
        [WizardStepBasicsTestIds.checkboxPolicyActive]: null,
        [WizardStepBasicsTestIds.datepickerValidFrom]:
            'Optionaler Gültigkeitszeitraum — vor diesem Datum ist die Richtlinie inaktiv.',
        [WizardStepBasicsTestIds.datepickerValidTo]:
            'Optionaler Gültigkeitszeitraum — nach diesem Datum ist die Richtlinie inaktiv.',
        [WizardStepBasicsTestIds.errorValidTo]: null,
    },
}
